/**
 * Okna czasowe rytuałów tygodniowych — wspólne dla bannerów i przycisków.
 * Single source of truth dla decyzji "kiedy pokazać rytuał".
 *
 * Filozofia: rytuał jest scaffoldingiem rozmowy, nie dark patternem.
 * Banery sam znikają poza oknem — brak push'y "ominąłeś".
 */

/**
 * Friday Recap — od piątku 17:00 do końca niedzieli.
 * Trzy dni okna pozwalają rodzinie "trafić" w naturalny moment
 * (piątek wieczór, sobotni poranek, niedzielny obiad).
 */
export function isInRecapWindow(now = new Date()): boolean {
  const day = now.getDay(); // 0=ND, 5=PT, 6=SO
  const hour = now.getHours();
  if (day === 5 && hour >= 17) return true;
  if (day === 6) return true;
  if (day === 0) return true;
  return false;
}

/**
 * Sunday Plan — niedziela cały dzień + poniedziałek do 9:00.
 * Niedziela = naturalny moment planowania, poniedziałek rano = catch-up
 * dla rodzin które nie zdążyły. Po 9:00 w pn nowy tydzień już się zaczął.
 */
export function isInPlanWindow(now = new Date()): boolean {
  const day = now.getDay(); // 0=ND, 1=PN
  const hour = now.getHours();
  if (day === 0) return true;
  if (day === 1 && hour < 9) return true;
  return false;
}
